import request from '@/utils/request'

export function getMenuList() {
  return request({
    url: '/front/home/menu-list',
    method: 'post',
    data: {
      sys_type: 'official'
    }
  })
}     

export function getSubMenuList(pcode, listtpl) {
  return request({
    url: '/front/home/sub-menu-list',
    method: 'post',
    params: {
      pcode: pcode,
      listtpl: listtpl
    }
  })
}

export function getNewsList(params) {
  return request({
    url: '/front/home/get-news-list',
    method: 'post',
    params: params
  })
}

export function getNewsSolrList(params) {
  return request({
    url: '/front/home/get-news-solr-list',
    method: 'post',
    params: params
  })
}

export function getAuctionList(params) {
  return request({
    url: '/front/home/get-auction-list',
    method: 'post',
    params: params
  })
}

export function getAuctionSolrList(params) {
  return request({
    url: '/front/home/get-auction-solr-list',
    method: 'post',
    params: params
  })
}

export function getHotNews(params) {
  return request({
    url: '/front/home/get-hot-news',
    method: 'post',
    params: params
  })

}

export function getBannerList(params) {
  return request({
    url: '/front/home/get-banner-list',
    method: 'post',
    params: params
  })
}


export function getLabelList(params) {
  return request({
    url: '/front/home/get-label-data',
    method: 'post',
    params: params
  })
}

export function getLabelListByType(type) {
  return request({
    url: '/front/home/get-label-list-by-type',
    method: 'post',
    params: { type }
  })
}

export function getPropertyList(params) {
  return request({
    url: '/front/home/get-property-list',
    method: 'post',
    params: params
  })

}

export function getPropertySolrList(params) {
  return request({
    url: '/front/home/get-property-solr-list',
    method: 'post',
    params: params
  })

}

export function getNewsDetail(id,sign) {
  return request({
    url: '/front/home/get-news-detail',
    method: 'post',
    params: { id,sign }
  })
}

export function getPrevNextNews(infoType, id, keyword) {
  return request({
    url: '/front/home/get-prev-next-news',
    method: 'post',
    params: { infoType, id, keyword }
  })
}

export function getPrevNextSolrNews(infoType, id, keyword) {
  return request({
    url: '/front/home/get-prev-next-solr-news',
    method: 'post',
    params: { info_type: infoType, id, keyword }
  })
}

export function getPrevNextSolrAuction(infoType, id, keyword, assetType, sort, categoryId) {
  return request({
    url: '/front/home/get-prev-next-solr-auction',
    method: 'post',
    params: { info_type: infoType, id, keyword, assetType, sort, categoryId }
  })
}

export function getPrevNextSolrProperty(infoType, id, keyword, isLease, assetType, sort, categoryId) {
  return request({
    url: '/front/home/get-prev-next-solr-property',
    method: 'post',
    params: { info_type: infoType, id, keyword, isLease, assetType, sort, categoryId }
  })
}

export function getPrevNextRecruitment(jobCategory, id) {
  return request({
    url: '/front/home/get-prev-next-recruitment',
    method: 'post',
    params: { jobCategory, id }
  })
}

export function getPrevNextSolrRecruitment(jobCategory, id) {
  return request({
    url: '/front/home/get-prev-next-solr-recruitment',
    method: 'post',
    params: { jobCategory, id }
  })
}

export function getAuctionDetail(id,sign) {
  return request({
    url: '/front/home/get-auction-detail',
    method: 'post',
    params: { id,sign }
  })
}

export function getHomeBadAssets(params) {
  return request({
    url: '/front/home/get-home-bad-assets',
    method: 'post',
    params: params
  })
}

export function getPropertyDetail(id, sign) {
  return request({
    url: '/front/home/get-property-detail',
    method: 'post',
    params: { id, sign }
  })
}

export function getCategoryList() {
  return request({
    url: '/front/home/get-category-list',
    method: 'post'
  })
}

export function getAyLinkList() {
  return request({
    url: '/front/home/get-link-list',
    method: 'post'
  })
}

export function getRecruitmentList(params) {
  return request({
    url: '/front/home/get-recruitment-list',
    method: 'post',
    params: params
  })
}
export function getRecruitmentSolrList(params) {
  return request({
    url: '/front/home/get-recruitment-solr-list',
    method: 'post',
    params: params
  })
}

export function getRecruitmentDetail(id,sign) {
  return request({
    url: '/front/home/get-recruitment-detail',
    method: 'post',
    params: { id,sign }
  })
}

export function getGlobalSearchList(data) {
  return request({
    url: '/front/home/get-all-search-list',
    method: 'post',
    params: data
  })
}

export function getSiteConfig(params) {
  return request({
    url: '/front/home/get-site-config',
    method: 'post',
    params: params
  })
}

export function getCompanyInfo() {
  return request({
    url: '/front/home/get-company-info',
    method: 'post'
  })
}

export function getSiteConfigList(params) {
  return request({
    url: '/front/home/get-site-config-list',
    method: 'post',
    params: params
  })
}
